/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { MachineResult } from "./traversal/result.js";
import { MachineEdgeState } from "./traversal/state.js";
export const replacer = (key, value) => {
    if (!(value instanceof Map))
        return value;
    return { $type: "Map", value: Array.from(value.entries()) };
};
export const reviver = (key, value) => {
    const { $type } = (value || {});
    return $type == "Map" && value.value
        ? new Map(value.value)
        : value;
};
export const saveRunnerState = (type, result) => {
    const state = result;
    return JSON.stringify({ state, type }, replacer);
};
export const loadRunnerState = (s) => {
    const { state: o, type } = JSON.parse(s, reviver);
    const state = MachineResult.fromObject(o);
    return { state, type };
};
export const cloneState = (result) => {
    const { descriptor, inputs, missingInputs, current, opportunities, newOpportunities, state, outputs, partialOutputs, } = result;
    const clonedValueState = new MachineEdgeState();
    clonedValueState.constants = structuredClone(state.constants);
    clonedValueState.state = structuredClone(state.state);
    const clone = new MachineResult(descriptor, inputs, [...missingInputs], current, [...opportunities], [...newOpportunities], clonedValueState, partialOutputs);
    clone.outputs = outputs;
    return clone;
};
//# sourceMappingURL=serialization.js.map